import axios from "axios";


const api = axios.create({

    baseURL: "https://api.felisiak.com.br"

});


export default api;